import { ViewportScroller } from '@angular/common';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable()
export class ScrollToService {

    constructor(
        public viewportScroller: ViewportScroller,
    ) { }

    scrollToID(elementName) {
        this.viewportScroller.scrollToAnchor(elementName);
    }
}
